import { array, func } from 'prop-types';
import React, { useRef } from 'react';

import '../styles/ProductImages.css';

const HOVER_TIMEOUT = 150;

function ProductImages({ images, setSelectedImage }) {
    const hoverTimeout = useRef(null);

    if (!images || images.length <= 1) {
        return null;
    }


    const handleMouseEnter = (imageUrl) => {
        hoverTimeout.current = setTimeout(() => {
            setSelectedImage(imageUrl);
        }, HOVER_TIMEOUT);
    };

    const handleMouseLeave = () => {
        clearTimeout(hoverTimeout.current);
    };

    return (
        <div
            className={'product-images'}
            aria-hidden={'true'}
            onClick={(e) => e.stopPropagation()}
        >
            {images.map((image) => {
                return (
                    <img
                        key={image.id}
                        src={image.url}
                        alt={''}
                        className={'product-images--img'}
                        onMouseEnter={() => handleMouseEnter(image.url)}
                        onMouseLeave={handleMouseLeave}
                    />
                );
            })}
        </div>
    );
}

ProductImages.propTypes = {
    images: array,
    setSelectedImage: func,
};

export default ProductImages;